import { Factory } from 'rosie';

Factory.define('GuideCollection');

Factory.define('GuideCollectionWithDefaults')
  .extend('GuideCollection')
  .attr('id', 'exampleGuideCollectionId')
  .attr('name', 'example guide collection name');
